import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "112vh",
    "& .MuiButtonBase-root": {
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: theme.palette.custom.main,
        color: "#fff",
      },
    },
    overflow: "auto",
  },
  loginContainer: {
  background: "rgba(255, 255, 255, 0.15)", 
  backdropFilter: "blur(10px)",             
  WebkitBackdropFilter: "blur(10px)",       
  border: "1px solid rgba(255, 255, 255, 0.3)",
    // boxShadow:
    // "0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08)",
    // borderRadius: 20,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    margin: "0px 50px",
    padding: "40px 50px",
    borderRadius:"10px"
  },
  // loginWrapper: {
  //   alignItems: "center",
  // },
  // imgContainer: {
  //   alignSelf: "center",
  // },
  gridFields: {
    width: "100%",
    paddingBlock: 8,
  },
  logo: {
    width: "10%",
    height: "10%",
    objectFit: "cover",
  },
  forgotPassWordLabel: {
    alignSelf: "center",
  },
  forgotLabel: {
    cursor: "pointer",
    opacity: 0.8,
    fontSize: 30,
    paddingBlock: 4,
  },
  password: {
    "&.MuiSvgIcon-root": {
      cursor: "pointer",
    },
  },
  loginPageImage: {
    width: "100%",
    height: "112vh",
    objectFit: "cover",
    position: "relative",
    filter:"brightness(0.8)",
  },
  membersbutton:{
    background:"white"
  },

  loginImageContainer: {
    position: "relative",
  },
  overlayText: {
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "start",
    flexDirection: "column",
   top: 50,
    left: 0,
    bottom: 50,
    width: "100%",
    //backgroundColor: "rgba(0, 0, 0, 0.6)",
    color: "white",
    padding: "10px",
  },
  gridContainer: {
    display: "flex",
    padding: "30px",
    flexDirection: "column",
    alignItems: "center",
     height:"40%",
       marginTop:"60%",
  },
  gridItem: {
    flex: "1",
    bottom:0,
   
  },
  boldertext:{
 fontWeight:"bold"
  },
  boldText: {
    fontSize: "52px",
    fontWeight: "bold",
  },
  highlightText: {
    color: "#c4c4c4",
    fontSize: "32px",
  },
  highlightTextBig: {
    color: "#c4c4c4",
    fontSize: "52px",
  },

whiteBgBlackText_WhiteBorder: {
  backgroundColor: 'white',
  borderRadius: '5px',

  // Label color (default + focused)
  '& .MuiInputLabel-root': {
    color: 'black',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'white',
  },

  // Input text color
  '& .MuiInputBase-input': {
    color: 'black',
  },

  // Outline / border color
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'white',
    },
    '&:hover fieldset': {
      borderColor: 'white',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'white',
    },
  },

  // Helper text color (optional)
  '& .MuiFormHelperText-root': {
    color: '#ffcccc',
  },
},



}));

export default useStyles;
